module.exports = __webpack_public_path__ + "img/dialStatus.28670ab0.png";